import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export type EnrollStep = 'consent' | 'selfie' | 'data';

const STEPS: Array<{ key: EnrollStep; label: string }> = [
  { key: 'consent', label: 'Termos' },
  { key: 'selfie', label: 'Selfie' },
  { key: 'data', label: 'Dados' },
];

type Props = { current: EnrollStep };

/** Progresso do cadastro — a mesma barra em todas as telas do funil. */
export function EnrollStepper({ current }: Props) {
  const currentIndex = STEPS.findIndex((s) => s.key === current);
  return (
    <Box className="enroll-stepper" role="list" aria-label="Etapas do cadastro">
      {STEPS.map((step, index) => {
        const state = index < currentIndex ? 'done' : index === currentIndex ? 'active' : 'pending';
        return (
          <Box key={step.key} className={`enroll-stepper__step enroll-stepper__step--${state}`} role="listitem">
            <Box className="enroll-stepper__dot" aria-hidden>
              {state === 'done' ? <CheckIcon sx={{ fontSize: 14 }} /> : index + 1}
            </Box>
            <Typography component="span" className="enroll-stepper__label">
              {step.label}
            </Typography>
            {index < STEPS.length - 1 && <Box className="enroll-stepper__line" aria-hidden />}
          </Box>
        );
      })}
    </Box>
  );
}
